import type { Warehouse } from '@/warehouse.d';

import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';

import { getWarehouses } from '@/data/api/kundportal/requests';

const jsonSerializer = {
  read: (v: any) => (v ? JSON.parse(v) : null),
  write: (v: any) => JSON.stringify(v),
};

const promises = {};

export const usePostalcodeStore = defineStore('postalcode', {
  state: () => ({
    _postalcode: useStorage<string>('benders_postalcode', '', undefined, {
      serializer: jsonSerializer,
    }),
    warehouseLocation: {},
    warehouses: {} as Record<string, Warehouse[]>,
  }),
  actions: {
    setWarehouseLocation({ artnr, warehouse }: { artnr: string; warehouse: Warehouse }) {
      if (!artnr || !warehouse) return;
      this.warehouseLocation[artnr] = warehouse;
    },
    async getWarehouses(region: string = 'default', force = false) {
      let warehouses = [] as Warehouse[];
      if (!force) {
        warehouses = this.warehouses?.[region] ?? [];
        if (warehouses.length) return warehouses;
      }
      if (!promises[region]) {
        promises[region] = getWarehouses('info', '', region !== 'default' ? region : '').then((data: any) => {
          if (data?.success) {
            return data?.data;
          }
          return [];
        });
      }
      if (promises[region]) {
        warehouses = await promises[region];
      }
      promises[region] = null;
      this.warehouses[region] = warehouses;
      return warehouses;
    },
    setPostalcode(postalcode: string) {
      this._postalcode = postalcode;
      this.warehouseLocation = {}; // Reset warehouse location
    },
    setWarehouses(region: string, warehouses: Warehouse[]) {
      this.warehouses[region] = warehouses;
    },
  },
  getters: {
    postalcode(state) {
      if (!state._postalcode || typeof state._postalcode !== 'string') return '';
      return state._postalcode.replace(/\s/g, '').replace(/\D/g, '');
    },
  },
});
